import React, { Fragment } from "react";
import { Link, useHistory } from "react-router-dom";

import { clearDemoResult } from "./demoSession";
import "./Demo.css";

const EXPECTATIONS = [
  "Up to 10 curated demo questions",
  "A 4-minute countdown timer",
  "Instant score in study mode — answers stay locked",
  "No account or subscription required",
];

const DemoExam = () => {
  const history = useHistory();

  const startDemo = () => {
    clearDemoResult();
    history.push("/demo/quiz");
  };

  return (
    <Fragment>
      <div className="demo-page">
        <div className="demo-page__inner">
          <ul className="demo-page__breadcrumb">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>Try a Demo</li>
          </ul>

          <div className="demo-page__hero">
            <span className="demo-page__hero-icon">
              <i className="fas fa-play-circle" />
            </span>
            <p className="demo-page__kicker">Free · No sign-up needed</p>
            <h1 className="demo-page__title">Try One Time Success Demo Exam</h1>
            <p className="demo-page__lead">
              Practice with selected demo questions in a timed CBT experience.
              You get an instant score in study mode; correct answers stay locked
              until you subscribe — the same flow as the mobile app.
            </p>
          </div>

          <div className="demo-page__card">
            <h2 className="demo-page__card-title">What to expect</h2>
            <ul className="demo-page__list">
              {EXPECTATIONS.map((item) => (
                <li key={item}>
                  <i className="fas fa-check-circle" /> {item}
                </li>
              ))}
            </ul>
          </div>

          <div className="demo-page__actions">
            <button type="button" className="demo-page__btn demo-page__btn--green" onClick={startDemo}>
              Start Demo Exam <i className="fas fa-arrow-right" />
            </button>
            <Link className="demo-page__btn demo-page__btn--ghost" to="/exams">
              Browse exam plans
            </Link>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default DemoExam;
